// extracted by mini-css-extract-plugin
export var banner = "_fu-0";
export var closeButton = "_fu-2";
export var greenCheckmark = "_fu-3";
export var hereLink = "_fu-4";
export var titleIcon = "_fu-1";